import { createContext } from "react";

const BusContext = createContext();

export default BusContext;